import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

const Toaster = (props: ToasterProps) => {
  return (
    <SonnerToaster
      richColors
      position="top-center"
      duration={8000}
      closeButton
      {...props}
    />
  );
};

export { Toaster };
export { toast } from "sonner";
